import { useMemo } from "react";
import bundledCompetitionTypeMap from "tokens/build/js/competition-type-map";
import { getCompetitionTypeInfo } from "./getCompetitionTypeInfo";

export type CompetitionType = string & keyof typeof bundledCompetitionTypeMap;

export const competitionTypeKeys = Object.keys(bundledCompetitionTypeMap) as CompetitionType[];

export type UseCompetitionTypeProps = {
  sport?: string;
  league?: string;
  competition?: string;
  competitionType?: CompetitionType;
};

export type UseCompetitionTypeReturn = {
  sport?: string;
  league?: string;
  competition?: string;
};

export const useCompetitionType = ({
  sport = "",
  league = "",
  competition = "",
  competitionType,
}: UseCompetitionTypeProps = {}): UseCompetitionTypeReturn => {
  return useMemo(() => {
    if (competitionType === "") return { sport: "__noop__", league: "__noop__", competition: "__noop__" };
    const _league = competition || league;
    const info = competitionType ? getCompetitionTypeInfo(competitionType) : null;
    if (!info) return { sport, league: _league, competition: _league };

    return {
      sport: info.sport || "",
      league: info.competition || "",
      competition: info.competition || "",
    };
  }, [sport, league, competition, competitionType]);
};
